import {configuratorState} from "../../state";

const FormatOrientationData = (orientationSection) => {
  
  configuratorState.mainOrientationMenu = orientationSection;
  
  /*
  ---------------------------------------------------------------------------
   main parts menu
*/
  
  orientationSection.selected = orientationSection.menu[0].title;
  
  const orientationSectionNav = {};
  const orientationPartsMenu = [];
  
  orientationSection.menu.forEach((item) => {
    orientationPartsMenu.push({
      title: item.title
    })
  })
  
  // set first as default
  orientationSectionNav.selected = orientationSection.menu[0].title;
  // set menu
  orientationSectionNav.menu = orientationPartsMenu;
  
  configuratorState.orientationPartsMenu = orientationSectionNav;
  
  /*
---------------------------------------------------------------------------

*/
  
  const orientationPartsData= {};
  
  orientationSection.menu.forEach((item, index) => {
  
    orientationPartsData[item.title] = orientationSection.menu[index];
    delete orientationPartsData[item.title].title;
    
  });
  
  // console.log('orientationPartsData', orientationPartsData)
  
  configuratorState.orientationPartsData = orientationPartsData;
  
  
  
  
  
  
  
  
  
  
  
  
  
  /*
---------------------------------------------------------------------------

*/
  // configuratorState.orientationPartsMenu = orientationPartsMenu;

  
  // const mainFeaturesMenus = JSON.parse(JSON.stringify(mainFeaturesSectionMenus));
  //
  // const featuresMenu = {
  //   'selectedFeaturePartsGroup': '',
  //   menu: []
  // };
  //
  // mainFeaturesMenus.forEach((item, index) => {
  //
  //   // set default
  //   if (index === 0) featuresMenu['selectedFeaturePartsGroup'] = item.title;
  //
  //   featuresMenu.menu.push({
  //     title: item.title,
  //     link: item.link,
  //   });
  // });
  //
  // configuratorState.featuresMenu = featuresMenu;
  
  /*
     ---------------------------------------------------------------------------
     main parts menu
  */
 
  
};

export default FormatOrientationData;
